import * as _ from 'lodash';
export default {
  /**
   * Formatter: Formats the given value as a phone number in the following format: (xxx) xxx-xxxx.
   * Parser:  Retrieves the phone number as an integer from the given string.
   * @param {String} value the value to format
   */
  phone: {
    format: value => {
      // Since the value can be 0 based on the parser return value we need to detect
      // this and return an empty string.
      if (value === 0) {
        return '';
      }
      let groupRegex = /(\d{1,3})?(\d{1,3})?(\d{1,4})?/;
      let valueNumbers = ('' + value).replace(/[^\d]/g, '');

      let numberGroups = groupRegex.exec(valueNumbers);

      let formatted = '' +
        (numberGroups[1] !== undefined ? '(' + numberGroups[1] : '') +
        (numberGroups[2] !== undefined ? ') ' + numberGroups[2] : '') +
        (numberGroups[3] !== undefined ? '-' + numberGroups[3] : '');

      return formatted;
    },
    parse: valueString => {
      return valueString.replace(/[^\d]/g, '').slice(0, 10);
    }
  },
  /**
   * Formatter: Formats the given value as a number that includes a single preceding dash and commas every 3 digits, counting from the right.
   * Parser: Removes any character that is not a single preceding dash or a digit and retrieves the numerical value from the given string.
   * @param {String} value the value to format
   */
  numberWithCommas: {
    format: value => {
      return ('' + value).replace(/(^-)?(\d{1,3})(?=(\d{3})+(?!\d))/g, '$&,');
    },
    parse: valueString => {
      let negVal = valueString[0] === '-' ? -1 : 1;
      let value = Number(valueString.replace(/(^[^-\d]|[^\d])/g, ''));
      return Number.isNaN(value) ? 0 : value * negVal;
    }
  },

  expirationDate: {
    format: value => {
      return value.substr(0, 2) + ' / ' + value.substr(2, 2);
    },
    parse: valueString => {
      return valueString.replace(/[^0-9]/g, '');
    }
  },

  ccNumber: {
    format: value => {
      if (_.isNumber(value)) {
        return '';
      }

      value = value.replace(/[^\d]/g, '');
      let card = value.substr(0, 4);
      if (value.length > 4) {
        card += ' ' + value.substr(4, 4);
      }
      if (value.length > 8) {
        card += ' ' + value.substr(8, 4);
      }
      if (value.length > 12) {
        card += ' ' + value.substr(12, 4);
      }
      return card;
    },
    parse: valueString => {
      return valueString.replace(/\s/g, '');
    }
  },
  uppercase: {
    format: value => {
      let formatted = value.toUpperCase();
      return formatted;
    },
    parse: valueString => {
      return valueString.toUpperCase();
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/FormatService.js